<app-section-template
  [sectionTitle]="'Important IFRS Foundation dates' | translate"
  theme="grey">
  <div class="wrapper">
    @for (event of data(); track event; let index = $index) {
      <a [href]="HELPER.getUrl(event.sourceUrl)">
        <div class="event">
          <div class="event-start-date">
            <div class="event-start-date--date">{{ event.startDate | onlyDate | date : "d" }}</div>
            <div class="event-start-date--month">{{ HELPER.LocalizedMonth(event.startDate) }}</div>
          </div>
          <div class="event-description">
            <div class="event-range">
              <span class="icon-Calendar-2"></span>
              @if (dateIsEqual(event.startDate, event.endDate)) {
                {{ HELPER.formatDateWithLocalizedMonth(event.startDate) }}
              } @else {
                {{ HELPER.formatDateWithLocalizedMonth(event.startDate) }}
                - {{ HELPER.formatDateWithLocalizedMonth(event.endDate) }}
              }
            </div>
            <div class="event-title">{{ event.title }}</div>
            <div class="event-location">{{ event.location }}</div>
          </div>
        </div>
      </a>
    }
  </div>
</app-section-template>
